import * as fallbackImage from '../../images/default-fallback-image.png';
import getImageUrl, { getFeaturedImage } from '../util/getImage'

export default class {

  constructor() {
    this.events();
    this.month = null
    this.year = null
    this.page = 1
  }

  filterData( append = false ) {
    const that = this
    const $wrapper = $('.js-eventFilters__cards')
    const $button = $('.js-eventFilters__moreBtn')
    // eslint-disable-next-line
    let url = `${API_BASE_URL}/events?`

    const params = {}
    if ( this.month ) {
      params['month'] = this.month
    }
    if ( this.year ) {
      params['year'] = this.year
    }
    if ( this.page > 1 ) {
      params['page'] = this.page
    }
    if ( Object.keys(params) ) {
      url += $.param(params)
    }

    $wrapper.addClass('is-loading')
    $wrapper.append('<div class="l-spinner"><div class="l-spinner__el"></div></div>')

    $button.find('span').text('Loading...')
    $button.addClass('is-loading')

    $.get( url, function( response ) {
      if ( response.events.data.length ) {

          const markup = that.getMarkup( response.events.data )

          const $spinner = $('.l-spinner')
          if ( $spinner.length ) {
            $spinner.remove()
          }

          if ( append ) {
            $wrapper.append(markup)
          } else {
            $wrapper.html(markup)
          }

          $wrapper.removeClass('is-loading')
          $button.find('span').text('Show more')
          $button.removeClass('is-loading')

          if( response.events.last_page === that.page ) {
            $button.hide()
          } else {
            $button.show()
          }
      } else {
        const noDataMarkup = `
          <div class="col-12 d-flex align-items-center justify-content-center mt-4">
            <p><strong>No events found</strong></p>
          </div>
        `
        $button.hide()
        $wrapper.html(noDataMarkup)
      }
    });
  }

  renderDateLabel(startDate, endDate = null) {
    if ( !startDate ) {
      return ''
    }

    startDate = new Date(startDate)
    const startDateMonth = startDate.toLocaleString('default', { month: 'long' })
    let endDateDay = null
    let endDateMonth = null

    if ( endDate ) {
      endDate = new Date(endDate)
      endDateMonth = endDate.toLocaleString('default', { month: 'long' })
      if( startDateMonth === endDateMonth ) {
        endDateMonth = null
      }
    }

    const startDateDay = startDate.getDate()
    if ( endDate ) {
      endDateDay = endDate.getDate()
      if( startDateDay === endDateDay ) {
        endDateDay = null
      }
    }

    let withDifferentEndMonth = ''
    if ( endDateDay && endDateMonth ) {
      withDifferentEndMonth += `
        <div class="l-dateLabel__body d-flex">
          <div>
            <p class="l-dateLabel__day">${startDateDay}</p>
            <p class="l-dateLabel__month">${startDateMonth}</p>
          </div>
          <span class="l-dateLabel__to">to</span>
          <div>
            <p class="l-dateLabel__day">${endDateDay}</p>
            <p class="l-dateLabel__month l-dateLabel__month--end">${endDateMonth}</p>
          </div>
        </div>
      `
    }

    let content = ''
    content += `
      <div class="c-heroBanner__label l-dateLabel">
        ${
          ( endDateDay && endDateMonth ) ? (
            `${withDifferentEndMonth}`
          ) : (
            `
              <div class="l-dateLabel__body">
                <div class="l-dateLabel__dayWrapper">
                  <p class="l-dateLabel__day">${startDateDay}</p>
                  ${
                    endDateDay ? (
                      `
                        <span class="l-dateLabel__to">to</span>
                        <p class="l-dateLabel__day">${endDateDay}</p>
                      `
                    ) : ''
                  }
                </div>
                <p class="l-dateLabel__month">${startDateMonth}</p>
              </div>
            `
          )
        }
      </div>
    `

    return content
  }

  getMarkup(events) {
    if ( !events.length ) return

    let content = ''

    events.map( event => {
      const image = getImageUrl(getFeaturedImage(event.images), 'default', '559x327')
      const restaurant = event['venue']
      content += `
          <div class="col-lg-4 col-md-6">
            <a href="/events/${event['slug']}" class="c-eventCard l-card">
            <div class="c-eventCard__header">
              <div class="h-objectImage h-objectImage--12by7 js-objectImage l-card__imageWrapper visible">
                ${
                  image ? (
                    ` 
                      <img class="l-card__image" src="${ image }">
                    `
                  ) : (
                    `<img class="l-card__image" src="${fallbackImage}">`
                  )
                }
              </div>
            </div>
            <div class="c-eventCard__body l-card__body">
                <h2 class="c-eventCard__title l-card__title h4">${event['title'] }</h2>
                <p class="c-eventCard__subtitle l-card__subtitle">
                ${
                  restaurant && (
                    ( restaurant['addr_city'] && restaurant['addr_county'] ) && (
                      `${restaurant['addr_city']} , ${restaurant['addr_county']}`
                    ) 
                  )
                }
                </p>
              <p class="c-eventCard__readMore l__readMore h-navLink h-navLink--seeMore d-block">Full details</p>
            </div>
            ${this.renderDateLabel(event['start_date'], event['end_date'] )}
          </a>
        </div>
      `
    })
   return content
  }

  events() { 
    $('.js-eventFilters__moreBtn').on('click', (e) => {
      e.preventDefault()
      this.page++
      this.filterData(true)
    })

    $('.js-eventFilters__dropdown').on('change', (e) => {

      const $this = $(e.target)
      const value = e.target.value

      this.page = 1

      if ( $this.hasClass('c-eventFilters__dropdown--year') ) {

        this.year = value
        this.filterData()

      } else if ( $this.hasClass('c-eventFilters__dropdown--month') ) {

        this.month = value
        this.filterData()

      }
    })

  }

}